var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13240",
    "data-name": "Group 13240",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.35,
    height: 28.097,
    viewBox: "0 0 24.35 28.097",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6887",
    "data-name": "Rectangle 6887",
    width: 24.35,
    height: 28.097,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13239",
    "data-name": "Group 13239",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24161",
    "data-name": "Path 24161",
    d: "M29.814,31.349a17.108,17.108,0,0,0,1.7,7.484c-.146.138-.331.1-.5.1q-3.4,0-6.793,0-5.753,0-11.507,0c-.18,0-.375.045-.531-.1a17.483,17.483,0,0,0,1.471-4.665,32.151,32.151,0,0,0,.233-5.194,7.838,7.838,0,0,1,2.479-5.745,7.7,7.7,0,0,1,3.627-1.978c.1-.024.2-.065.3-.1.319-.2.692-.121,1.035-.2.083-.019.173,0,.258-.022a4.31,4.31,0,0,0,.521,0c.326.026.652.062.976.1a.448.448,0,0,1,.318.116,12.507,12.507,0,0,1,1.679.559,9.424,9.424,0,0,1,1.222.677c.012.149-.107.222-.19.312a5.09,5.09,0,0,0,1.06,7.816,5.16,5.16,0,0,0,2.345.743c.1.01.218-.014.3.086",
    transform: "translate(-10.603 -18.224)",
    fill: "#fbbe49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24162",
    "data-name": "Path 24162",
    d: "M1.578,159.09l17.52,0c.6,0,1.209,0,1.813,0a1.434,1.434,0,0,1,1.577,1.605c0,.517,0,1.034,0,1.551,0,.435-.163.6-.6.6H15.769c-.117,0-.233.008-.35.013a.716.716,0,0,1-.423.082h-7.5a.72.72,0,0,1-.423-.082c-1.033,0-2.067-.011-3.1-.013-1.122,0-2.243,0-3.365,0-.441,0-.6-.159-.6-.6,0-.517,0-1.034,0-1.551a1.432,1.432,0,0,1,1.577-1.6",
    transform: "translate(0 -138.48)",
    fill: "#f67f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24163",
    "data-name": "Path 24163",
    d: "M113.647,31.946a5.164,5.164,0,0,1-3.689-8.765c.061-.062.118-.129.177-.193a5.609,5.609,0,0,1,2.557-1.272,5.153,5.153,0,1,1,1.883,10.133c-.3.06-.619.066-.929.1",
    transform: "translate(-94.436 -18.82)",
    fill: "#d52828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24164",
    "data-name": "Path 24164",
    d: "M54.569,188.066c.321,0,.642-.013.963-.013q3.5,0,7.008,0c.126,0,.253.008.379.013a4.208,4.208,0,0,1-8.294.4c-.03-.132-.038-.269-.056-.4",
    transform: "translate(-47.5 -163.691)",
    fill: "#fbbe49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24165",
    "data-name": "Path 24165",
    d: "M75.761,2.931l-1.344-.149c.022-.122.143-.115.219-.163a.867.867,0,0,0,.4-.98.887.887,0,0,0-.825-.625.86.86,0,0,0-.824.622.885.885,0,0,0,.395.984c.076.049.2.041.219.164l-1.344.149A1.877,1.877,0,1,1,75.888,2.7c-.039.079-.084.154-.126.231",
    transform: "translate(-62.963 0)",
    fill: "#003049"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24166",
    "data-name": "Path 24166",
    d: "M80.278,9.065a.95.95,0,0,1-.722-1.024.961.961,0,0,1,.859-.821A.936.936,0,0,1,80.7,9.065a.909.909,0,0,1-.42,0",
    transform: "translate(-69.243 -6.282)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24167",
    "data-name": "Path 24167",
    d: "M133.526,43.851a.542.542,0,0,1-.153.4q-1.36,1.589-2.722,3.176a.475.475,0,0,1-.782.024q-.669-.655-1.324-1.324a.467.467,0,1,1,.655-.661c.283.269.568.537.826.829.166.188.249.138.387-.025q1.113-1.319,2.244-2.623a.466.466,0,0,1,.83.068.9.9,0,0,1,.039.137",
    transform: "translate(-111.744 -37.8)",
    fill: "#fefefe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.a8461867b09566fff17f2e96b71c18f4.svg";
export { ForwardRef as ReactComponent };